import styled from 'styled-components'

export const FooterContainer = styled.div `
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;

    padding: 2rem 0;
    font-size: 1.2rem;
    font-family: 'Pacifico', cursive;
`